import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import ButtonLoading from "../../../assets/loaders/ButtonLoading";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { allRoutes } from "../../../assets/routes/allRoutes";
import TMScontentIcon from "../../../assets/images/dezenCrmLogin.png";
import DEZENLoginIcon from "../../../assets/images/dezen.png";
import MainServices from "../../../services/MainServices";
import useAuth from "../../../hooks/useAuth";
import axios from "axios";
import "./resetPassword.scss";
import { PasswordInput, PrimaryInput } from "../../../assets/FormElements";
import CustomErrorMessage from "../../../assets/elements/ErrorMessage";
import { PrimaryButton } from "../../../assets/buttons";
import { Label } from "reactstrap";
import { notifySuccess, notifyWarn } from "../../../assets/elements/Toast";
import * as Storage from "../../../store/LocalStorage";
import useConfig from "../../../hooks/useConfig";

const resetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is Required")
    .min(8, "Atleast Eight(8) Characters")
    .max(12, "Atmost Twelve(12) Characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,12}$/,
      "Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character"
    ),
});

const ResetPassword = () => {
  const navigate = useNavigate();
  let { user, updateUserContext } = useAuth();
  const { getUserDetails, resetpassword } = MainServices();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const config = useConfig();

  const resetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,12}$/,
        "Password must be between 8 and 12 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character from @$!%*?&."
      ),

    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Passwords must match"
    ),
  });
  useEffect(() => {
    getUserByUserId();
  }, []);

  const getUserByUserId = async () => {
    const details = {};
    const token = user.token;
    await axios.all([getUserDetails(details, token)]).then(function (res) {
      if (res[0]) {
        let resData = res[0];
        let message = resData.message;
        if (resData.success) {
          setUserDetails(resData.data);
        }
      }
    });
  };

  const onPasswordChange = async (values) => {
    setButtonLoading(true);

    const publicId = userDetails?.publicId;
    const concurrencyStamp = userDetails?.concurrencyStamp;
    const details = {
      password: values.password,
    };

    await resetpassword(details, publicId, concurrencyStamp)
      .then(async (res) => {
        const resData = res;
        if (resData.success) {
          notifySuccess("Password Changed Successfully");
          Storage.clear();
          window.location.reload();
        } else {
          notifyWarn("Error Occured!");
        }
      })
      .catch((err) => console.error(err));

    setButtonLoading(false);
  };

  return (
    <div className="account-content">
      <div className="login-content">
        <div className="login-user-info">
          <div className="login-logo">
            <img src={DEZENLoginIcon} alt="Dezen Logo" />
          </div>
          <div className="reset-password-box">
            <div style={{ fontWeight: "700", marginBottom: "10px" }}>
              Reset Your Password
            </div>

            <div>
              <Formik
                initialValues={{
                  password: "",
                  confirmPassword: "",
                }}
                validationSchema={resetPasswordSchema}
                onSubmit={(values) => {
                  onPasswordChange(values);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <Form className="form" onSubmit={handleSubmit}>
                    <div className="form-group">
                      <Label style={{fontSize:"16px"}}>Enter New Password</Label>
                      <PasswordInput
                        placeholder="Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        name="password"
                      />
                      <CustomErrorMessage
                        name="password"
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div className="form-group">
                      <Label  style={{fontSize:"16px"}}>Confirm New Password</Label>
                      <PasswordInput
                        placeholder="Confirm Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.confirmPassword}
                        name="confirmPassword"
                      />
                      <CustomErrorMessage
                        name="confirmPassword"
                        errors={errors}
                        touched={touched}
                      />
                    </div>

                    <div className="mt-5">
                      <PrimaryButton
                        type="submit"
                        title={
                          buttonLoading ? <ButtonLoading /> : "Change Password"
                        }
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-image">
        <img src={TMScontentIcon} alt="TMS Content" />
      </div>
    </div>
  );
};

export default ResetPassword;
